import { Channel, ChatRoomType, ChatRoomProps, MesgFilter, MesgFilterInfo } from '@dinosband/bv-main-schema/dist/types'
import { parseMesgFilter, _isEmptyFilter, _isFiltered, _isEqualFilter, _isEqualFilterInfo, _logFilter, _logFilterMap, _logFilterInfo, createMesgFilterInfo, EMPTY_MESG_FILTER_INFO } from '@dinosband/bv-data-center'
import settings from '@dinosband/bv-settings'

import { dataCenter, MessengerContext } from '../..'
import { ChatRoomControllerPool } from '../../controller-pool'
import { registerCid, updateFilteredMessageCache } from '../../controller/filter/message-to-cache'

const _DEBUG_LOG = true
// const _DEBUG_LOG = process.env.NODE_ENV !== 'production'
//                    && !!process.env.VUE_APP_MESSENGER_DEBUG_LOG
//                    && false
//  && false

// export interface ChatRoomMessageFilterInfo {
//   chatRoomId: number
//   filter?: MesgFilter
//   filterEnabled: boolean
// }

export class MessageFilterController {

  context: MessengerContext
  controllerPool: ChatRoomControllerPool

  private _messageFilterInfoMap: Record<number, MesgFilterInfo> = {} // number is chatRoomId

  constructor (context: MessengerContext, controllerPool: ChatRoomControllerPool) {
    this.context = context
    this.controllerPool = controllerPool
  }

  init () {
    const filters = settings.mesgFilterInfo
    for (const i in filters) {
      const chatRoomId = Number(i)
      if (!Number.isSafeInteger(chatRoomId) || chatRoomId <= 0) {
        continue
      }
      const filter = filters[chatRoomId]
      this._messageFilterInfoMap[chatRoomId] = filter
      if (_isFiltered(filter)) {
        registerCid(chatRoomId)
      }
    }
  }

  cleanup () {
    this._messageFilterInfoMap = {}
  }

  /*
  updateMessageFilterInfo (profileChannels: Profile_Channel[], replaceAll = false) {
    const targets: number[] = []
    for (const i of profileChannels) {
      let filter = parseMesgFilter(i.mesgFilter)
      if (_isEmptyFilter(filter)) {
        filter = undefined
      }
      const targets_ = this.setChannelFilter(i.channel, filter)
      targets.push(...targets_)
    }
    if (replaceAll) {
      const exists = Object.keys(this._messageFilterInfoMap).map(Number)
      const outdateds = _difference(exists, targets)
      if (outdateds.length > 0) {
        const filters_ = settings.messageFilters
        const isFiltered_ = settings.chatRoomIsFiltered
        outdateds.forEach((i) => {
          delete this._messageFilterInfoMap[i]
          delete filters_[i]
          delete isFiltered_[i]
        })
        settings.messageFilters = filters_
        settings.chatRoomIsFiltered = isFiltered_
      }
    } else {
    }
  }*/

  initChannelFilter (channel: Channel) {
    const userId = this.context.mainStore?.userId
    if (!userId || userId <= 0) {
      return
    }
    const profile_c = this.context.mainStore.myProfileChannels.find((i) => i.channelId === channel.id)
    const filter = parseMesgFilter(profile_c?.mesgFilter)
    this.setChannelFilter(channel, filter)
  }

  setChannelFilter (channel: Channel, filter?: MesgFilter) {
    // const targetChatRoomIds: number[] = []
    if (filter) {
      filter = parseMesgFilter(JSON.stringify(filter))
    }
    if (_isEmptyFilter(filter)) {
      filter = undefined
    }
    const mainStore = this.context.mainStore
    for (const chatRoom of channel.chatRoomMenus.flatMap((i) => i.chatRoom ?? [])) {
      const chatRoomId = chatRoom.id
      if (mainStore.getChatRoomType(chatRoom) !== ChatRoomType.JOB_OFFER) {
        if (chatRoom.type === ChatRoomType.JOB_OFFER) {
          // 정보 게시판은 필터를 적용하지 않는다.
          this.setMesgFilterInfo(chatRoomId, EMPTY_MESG_FILTER_INFO)
        }
        continue
      }
      // targetChatRoomIds.push(chatRoomId)
      const prev = this._messageFilterInfoMap[chatRoomId]
      if (prev && _isEqualFilter(filter, prev.channelFilter)) {
        continue
      }
      const chatRoomProps = JSON.parse(chatRoom.props ?? '{}') as ChatRoomProps
      if (chatRoomProps.filterBar?.hide || chatRoomProps.filterBar?.hideFilter) {
        // 필터바가 없거나 필터 설정이 없는 경우에는 chatRoom 필터 삭제
        filter = undefined
      }
      const info = createMesgFilterInfo(filter)
      this.setMesgFilterInfo(chatRoomId, info)
    }
    // return targetChatRoomIds
  }

  // private mesgFilterInfo (chatRoomId: number): MesgFilterInfo | undefined {
  //   return this._messageFilterInfoMap[chatRoomId]
  // }

  setMesgFilterInfo (chatRoomId: number, info: MesgFilterInfo) {
    const prev = this._messageFilterInfoMap[chatRoomId]
    const copied = info ? JSON.parse(JSON.stringify(info)) : undefined
    settings.mesgFilterInfo = {
      ...settings.mesgFilterInfo,
      [chatRoomId]: copied,
    }
    this._messageFilterInfoMap[chatRoomId] = copied
    this.updateChatRoomFilter(chatRoomId, prev, info)
  }

  // private setChatRoomFilter (chatRoomId: number, filter?: MesgFilter): ChatRoomMessageFilterInfo | undefined {
  //   if (!filter) {
  //     const settings_ = settings.messageFilters
  //     delete settings_[chatRoomId]
  //     settings.messageFilters = settings_
  //     delete this._messageFilterInfoMap[chatRoomId]
  //     return
  //   }
  //   const info = this.registerChatRoomFilter(chatRoomId, filter)
  //   settings.messageFilters = {
  //     ...settings.messageFilters,
  //     [chatRoomId]: filter,
  //   }
  //   return info
  // }

  private async updateChatRoomFilter (chatRoomId: number, prev?: MesgFilterInfo, info?: MesgFilterInfo) {
    if (_isEqualFilterInfo(prev, info)) {
      return
    }
    await updateFilteredMessageCache(chatRoomId, [])
    // excludeMatchSets 적용
    const controller = this.controllerPool.chatRoomController(chatRoomId)
    controller?.setFilterInfo(info)
    dataCenter.filters.updateFilter(chatRoomId, info)
  }

}
